module.exports = {"pathContext":{"name":"ArBreakdown","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":"Breakdown by client/location","isDeprecated":false,"name":"CLIENT"},{"deprecationReason":null,"description":"Breakdown by order","isDeprecated":false,"name":"ORDER"},{"deprecationReason":null,"description":"Breakdown by organization","isDeprecated":false,"name":"ORG"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-ar-breakdown.json
// module id = 1210
// module chunks = 89804516164238